import { isStandardOrder } from '../../utils/order-type-utils';
import { getOrder } from './get-order';
export const getOrderSiteId = () => {
    const order = getOrder();
    return isStandardOrder(order) ? order.siteId : undefined;
};
